import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const useAddAdditionalWorkPanelStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    width: '100%',
    height: '100%'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
    height: 55,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0
  },
  headerTitle: {
    ...theme.typography.h4,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  },
  closeButton: {
    color: theme.palette.text.secondary
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 2, 3),
    gap: theme.spacing(2),
    flex: 1,
    overflowY: 'auto'
  },
  sectionLabel: {
    ...theme.typography.subtitle2,
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  optionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  optionCard: {
    cursor: 'pointer',
    userSelect: 'none',
    '&:focus': {
      outline: 'none'
    }
  },
  optionCardTop: {
    borderTop: `1px solid #e5e7eb`,
    borderLeft: `1px solid #e5e7eb`,
    borderRight: `1px solid #e5e7eb`,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    padding: theme.spacing(1.5, 1.5, 0.375),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.common.white,
    transition: 'background-color 0.15s'
  },
  optionCardTopSelected: {
    backgroundColor: theme.paintscout.palette.secondary[260].C95
  },
  optionCardTopRounded: {
    borderBottom: `1px solid #e5e7eb`,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    paddingBottom: theme.spacing(1.5)
  },
  optionCardBottom: {
    borderBottom: `1px solid #e5e7eb`,
    borderLeft: `1px solid #e5e7eb`,
    borderRight: `1px solid #e5e7eb`,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(0, 1.5, 1.5),
    backgroundColor: theme.palette.common.white,
    transition: 'background-color 0.15s'
  },
  optionCardBottomSelected: {
    backgroundColor: theme.paintscout.palette.secondary[260].C95
  },
  optionCardAreaName: {
    ...theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  },
  optionCardHours: {
    ...theme.typography.body2
  },
  optionCardOptionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  optionCardOptionName: {
    ...theme.typography.body2
  },
  optionSubareaRow: {
    paddingTop: theme.spacing(1.5),
    '& + &': {
      marginTop: theme.spacing(1)
    }
  },
  optionSubareaHeader: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: theme.spacing(1)
  },
  optionSubareaName: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightMedium as any,
    color: theme.palette.text.primary
  },
  optionSubareaDetail: {
    ...theme.typography.body2,
    whiteSpace: 'pre-wrap',
    '& p': { margin: 0 }
  },
  photoBadge: {
    backgroundColor: theme.paintscout.palette.secondary[260].C95,
    border: `1px solid ${theme.paintscout.palette.secondary[260].C60}`,
    color: theme.paintscout.palette.secondary[260].C50,
    fontSize: 12,
    padding: theme.spacing(0.125, 0.75),
    borderRadius: 4
  },
  addSelectedButton: {
    width: '100%',
    flexShrink: 0
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    flexShrink: 0
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.divider
  },
  dividerText: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0, 0.5)
  }
}))
